import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ServicePlanStepDefinition } from 'src/app/models/service-plan/service-plan-step-definition'
import { ServicePlanStepId } from 'src/app/models/service-plan/service-plan-step-id'

// The left-hand step rail (story e8-1 AC7/AC8). Numbered/checkmark badges + a text
// label per step — status is never colour alone. Only steps already reached are
// clickable (real <button>s, not disabled-as-decoration) — a step beyond
// maxReachedIndex cannot be jumped to ahead of validating everything before it.
@Component({
  selector: 'app-service-plan-step-rail',
  templateUrl: './step-rail.component.html',
  styleUrls: ['./step-rail.component.scss'],
  standalone: false,
})
export class StepRailComponent {
  @Input() steps: ServicePlanStepDefinition[] = []
  @Input() currentStepId!: ServicePlanStepId
  @Input() maxReachedIndex = 0
  @Output() stepSelected = new EventEmitter<ServicePlanStepId>()

  get currentIndex(): number {
    return this.steps.findIndex((step) => step.id === this.currentStepId)
  }

  isCompleted(index: number): boolean {
    return index < this.currentIndex
  }

  isCurrent(step: ServicePlanStepDefinition): boolean {
    return step.id === this.currentStepId
  }

  isReachable(index: number): boolean {
    return index <= this.maxReachedIndex
  }

  select(step: ServicePlanStepDefinition, index: number): void {
    if (this.isReachable(index) && !this.isCurrent(step)) {
      this.stepSelected.emit(step.id)
    }
  }
}
